module.exports = __webpack_public_path__ + "static/img/view.ec101d3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/view.png
// module id = 349
// module chunks = 7